// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disabled-style {
  border: none;
  background-color: #fff;
  padding-left: 0;
  padding-top: 0;
  font-weight: 500;
}
.disabled-style:disabled {
  background-color: #fff !important;
}

.placeholder-disabled {
  color: lightgray;
  font-style: italic;
  font-weight: 100;
}`, "",{"version":3,"sources":["webpack://./../common/src/Components/DynamicForm/formelements/FormElements.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AACF;AACE;EACE,iCAAA;AACJ;;AAGA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;AAAF","sourcesContent":[".disabled-style {\n  border: none;\n  background-color: #fff;\n  padding-left: 0;\n  padding-top: 0;\n  font-weight: 500;\n\n  &:disabled {\n    background-color: #fff !important;\n  }\n}\n\n.placeholder-disabled {\n  color: lightgray;\n  font-style: italic;\n  font-weight: 100;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
